<!--
 * @Author: your name
 * @Date: 2021-12-20 10:04:27
 * @LastEditTime: 2022-03-31 14:33:18
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /download/src/views/download.vue
-->
<template>
    <component :is="config.template" v-if="config" />
    <div v-else></div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import { IConfig } from '../store/modules/app-module'

/**
 *
 * @author
 * @create 2021-12-07 (星期二)
 */
@Component({
    name: 'download',
    components: {
        V1: () => import('./template/v1/index.vue'),
        V2: () => import('./template/v2/index.vue'),
        V3: () => import('./template/v3/index.vue')
    }
})
export default class extends Vue {
    /* props, data, getter */
    get config(): IConfig | null {
        return this.$store.app.config
    }

    /* life event: [mounted, beforeDestory] */
    async mounted(): Promise<void> {
        // > 获取url中携带的短链shortChain，并通过短链获取 gameId, channelId 参数
        await this.$store.app.parseUrl()
        // ? 检查是否处于微信环境
        this.$store.download.precheckEnvInWechat()
        // >
        await this.$store.app.loadGameInfo()
        await this.$store.app.loadWeChatGameInfo()
    }
    /* methods */
}
</script>

<style lang="less" scoped></style>
